import { RetailerFinancialProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerFinancial";

export const RetailerProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <RetailerFinancialProvider>{children}</RetailerFinancialProvider>;
};
